import React, { useState } from 'react'
import { GoChevronDown } from "react-icons/go";

const Search = ({options = ['Active', 'Products']}) => {

    const [value, setValue] = useState("");
    const [sugestValue, setSugestvalue]= useState(false);
    const suggestions = options.filter(option => option.toLowerCase().includes(value.toLowerCase()));
    const handleChnage = event =>{
        setValue(event.target.value);
    }
    const handlesuggestClick = (suggestion) => {
        setValue(suggestion);
        setSugestvalue(false)
    }
   
   

  return (
    <div className='in-main'>
       <div className="in"> <input type="text"  className='select-input' value={value} onChange={handleChnage} placeholder="Active" onFocus={() => setSugestvalue(true) } /></div>
        <div className="icon-down">
            <GoChevronDown className='go-icon'/>
        </div>
        {sugestValue && (
            <ul className='suggestions'>
                {suggestions.map(suggestion=>(
                    <li onClick={()=> handlesuggestClick(suggestion)} key={suggestion}>{suggestion}</li>
                ))}
            </ul>
        )}
    </div>

  )
}

export default Search